import React from 'react';
import Logo from './Logo.svg';
import cn from 'classnames'

import styles from './TopBar.module.css';
import { useLocation } from 'react-router-dom';
import useAuth from '@hooks/useAuth/useAuth';
import UserBlock from './UserBlock';

const routesWithCenterJustify = [
  '/change_password',
  '/forget',
]

const TopBar = () => {
  const router = useLocation();
  const [{ currentUser }] = useAuth();

  return (
    <div className={cn(
      styles.wrapper,
      routesWithCenterJustify.includes(router.pathname) && styles.center
    )}>
      <a className={styles.content} href='/'>
        <img src={Logo} alt='Bumpin platform' className={styles.logo} />
      </a>

      <div className={styles.background} />

      {currentUser && <UserBlock currentUser={currentUser} />}
    </div>
  )
}

export default TopBar;
